module.exports = __webpack_public_path__ + "img/cd7e937.png";